"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appendUrl = appendUrl;
exports.stringFormatter = exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*
 Copyright (c) 2018 Wells Fargo. 333 Market St., San Francisco, CA 94105 All rights reserved.
 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.
 */

/**
 * core-util
 *
 * Utility functions for object value transformation and URL creation
 *
 * @module core-util
 *
 * @author Vinothkumar V. Kalyanasundaram
 * @copyright 2018 Wells Fargo, All rights reserved.
 */

/**
 * Transforms values of a data structure with a transformer function
 *
 * @example
 *   const transformedData = util.stringFormatter(transformer)(data);
 *
 * @param {*} fn Transformer function applied to every "value" in the input data
 * @return {*} The input data structure where every "value" will be transformed
 * by the input function
 */
var stringFormatter = exports.stringFormatter = function stringFormatter(fn) {
  var _formatArray = function formatArray(arr) {
    arr.forEach(function (value, index) {
      // eslint-disable-next-line no-param-reassign
      if (typeof value === 'string') {
        arr[index] = fn(value);
      }
      if (_typeof(value) === 'object' && !Array.isArray(value)) {
        _formatObject(value); // NOSONAR
      }
      if (Array.isArray(value)) {
        _formatArray(value);
      }
    });
  };
  var _formatObject = function formatObject(data) {
    if (data === null) {
      return data;
    }
    Object.keys(data).forEach(function (key) {
      // eslint-disable-next-line no-param-reassign
      if (typeof data[key] === 'string') {
        data[key] = fn(data[key]);
      }
      if (_typeof(data[key]) === 'object' && !Array.isArray(data[key])) {
        _formatObject(data[key]);
      }
      if (Array.isArray(data[key])) {
        _formatArray(data[key]);
      }
    });
    return data;
  };
  return _formatObject;
};

/**
 * Appends URL paths to a base URL
 *
 * @example
 *   const fullUrl = util.appendUrl(base, context, path1, path2);
 *
 * @param {*} urls A set of URLs to append
 * @return {*} The new url
 */
function appendUrl() {
  for (var _len = arguments.length, urls = new Array(_len), _key = 0; _key < _len; _key++) {
    urls[_key] = arguments[_key];
  }
  if (!urls || urls.length === 0) {
    return '';
  }
  var lastSegment = '/' + urls.pop().replace(/^\//, '');
  var initialSegment = urls.reduce(function (accumulator, value) {
    return accumulator + (value ? '/' + value.replace(/^\//, '') : '');
  });
  return initialSegment + lastSegment;
}
var _default = exports["default"] = {
  stringFormatter: stringFormatter,
  appendUrl: appendUrl
};
//# sourceMappingURL=index.js.map